import React from "react";

const RMSLoader = ({ height, width }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 36"
      fill="none"
      className="animate-spin"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <!-- First partial circle border --> */}
      <circle
        cx="18.5"
        cy="18"
        r="12" // Adjust the radius for the first partial border
        fill="none"
        stroke="url(#paint1_linear_1508_1660)" // Use the same gradient as the path
        strokeWidth="1.5" // Adjust the stroke width as needed
        strokeDasharray="20" // Adjust the dash pattern (20 units of dash, 50 units of gap)
      />

      {/* <!-- Second partial circle border --> */}
      <circle
        cx="18.5"
        cy="18"
        r="18" // Adjust the radius for the second partial border
        fill="none"
        stroke="url(#paint1_linear_1508_1660)" // Use a different gradient or the same one as per your preference
        strokeWidth="1.5" // Adjust the stroke width as needed
        strokeDasharray="20" // Adjust the dash pattern (10 units of dash, 30 units of gap)
      />

      {/* <!-- Inner circle (on top) --> */}
      <circle
        cx="18.5"
        cy="18"
        r="8" // Adjust the radius for the inner circle
        fill="url(#paint0_linear_1508_1660)" // Use the same gradient as the path
      />

      {/* <!-- Existing path --> */}
      {/* <path
      d="M9.5604 16.7692C15.5787 16.7692 20.4528 11.895 20.4528 5.8846C20.4528 -0.12582 15.5787 4.07466e-06 9.5604 4.07466e-06C3.54214 4.07466e-06 -1.33203 4.86634 0.667969 10.8846C0.667969 16.895 5.54214 16.7692 9.5604 16.7692Z"
      fill="url(#paint0_linear_1508_1660)"
    /> */}

      <defs>
        <linearGradient
          id="paint0_linear_1508_1660"
          x1="4.58987"
          y1="3.65995"
          x2="15.4814"
          y2="14.9473"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#840C00" />
          <stop offset="0.618" stopColor="#D81E00" />
          <stop offset="1" stopColor="#FF620B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1508_1660"
          x1="10.2882"
          y1="19.901"
          x2="29.6039"
          y2="19.901"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#840C00" />
          <stop offset="0.618" stopColor="#D81E00" />
          <stop offset="1" stopColor="#FF620B" />
        </linearGradient>
        {/* <!-- Define another gradient for the second partial circle if needed --> */}
        <linearGradient
          id="paint2_linear_1508_1660"
          x1="10.2882"
          y1="19.901"
          x2="29.6039"
          y2="19.901"
          gradientUnits="userSpaceOnUse"
        >
          {/* <!-- Customize the colors for the second gradient --> */}
          <stop stopColor="#FF0000" />
          <stop offset="0.618" stopColor="#00FF00" />
          <stop offset="1" stopColor="#0000FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default RMSLoader;
